import React from 'react';
import type { AriaFocusProps } from '../../types/common';
import { DropdownFilter as DropdownFilterNew } from './DropdownFilter';
import { convertOldDropdownFilterProps } from './converter.old';
import type { OldDropdownFilterProps } from './converter.old';

export type DropdownFilterProps<OptionValue> = OldDropdownFilterProps<OptionValue>;

export const DropdownFilter = <OptionValue extends string | number>(
  props: DropdownFilterProps<OptionValue> & AriaFocusProps,
) => <DropdownFilterNew {...convertOldDropdownFilterProps(props)} />;
